import { StatusQuoAnalysisTabEnum } from '@/routes/search_params/searchParamsEnums';

const ACTIVE_TAB_STORAGE_PREFIX = 'active-tab';

export function storeActiveTab(storageKey: string, tab: StatusQuoAnalysisTabEnum) {
  try {
    localStorage.setItem(`${ACTIVE_TAB_STORAGE_PREFIX}-${storageKey}`, tab);
  } catch {
    console.error('Error storing active tab', storageKey, tab);
  }
}

export function getStoredActiveTab(storageKey: string): StatusQuoAnalysisTabEnum | null {
  try {
    const stored = localStorage.getItem(`${ACTIVE_TAB_STORAGE_PREFIX}-${storageKey}`);
    const validTabs: string[] = Object.values(StatusQuoAnalysisTabEnum);
    return stored && validTabs.includes(stored) ? (stored as StatusQuoAnalysisTabEnum) : null;
  } catch {
    console.error('Error getting stored active tab', storageKey);
    return null;
  }
}
